import { UseMutateFunction, useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { axiosInstance } from '@/lib/helpers'
import { queryKeys } from '@/lib/react-query/constants'

// for when server call is needed
async function deleteRoleAndPermissions(role_id: string): Promise<void> {
  await axiosInstance.delete(`/organization/role_permissions/${role_id}`)
}

export function useDeleteRoleAndPermissions(): UseMutateFunction<
  void,
  unknown,
  string,
  unknown
> {
  const queryClient = useQueryClient()
  const toast = useToast()

  const { mutate } = useMutation(deleteRoleAndPermissions, {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.rolesAndPermissions])
      toast({
        title: 'You have deleted the role and its permissions!',
        status: 'warning',
      })
    },
  })

  return mutate
}
